/* Ravegeist: countdown badges and the delivery-country chips on product pages. */
(function () {
  function initCountdowns(root) {
    root.querySelectorAll('[data-rg-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-rg-countdown') + 'T00:00:00');
      if (isNaN(target.getTime())) return;
      var days = Math.ceil((target.getTime() - Date.now()) / 86400000);
      var label = el.getAttribute('data-rg-label') || 'days';
      if (days > 0) {
        el.textContent = days + ' ' + label;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-rg-delivery]').forEach(function (box) {
      if (box.dataset.rgReady) return;
      box.dataset.rgReady = '1';
      var out = box.querySelector('[data-rg-delivery-text]');
      var chips = box.querySelectorAll('[data-rg-country]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          if (out) out.textContent = chip.getAttribute('data-rg-text');
        });
      });
    });
  }

  function init(root) {
    initCountdowns(root || document);
    initDelivery(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Re-run when sections are added or changed in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
